
























































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import useUser from '~/modules/customer/composables/useUser';

export default defineComponent({
  name: 'ProductPrices',
  props: {
    finalPrice: {
      type: [Number, String] as PropType<number | string>,
      default: null,
    },
    finalNettoPrice: {
      type: [Number, String] as PropType<number | string>,
      default: null,
    },
    omnibusPrice: {
      type: [Number, String] as PropType<number | string>,
      default: null,
    },
    isVariantSelected: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    sku: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup() {
    const { isAuthenticated, isB2bUser } = useUser();
    return {
      isB2bUser,
      isAuthenticated,
    };
  },
});
